var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useReducer, useState } from 'react';
import { ChatPanels } from '../../../types';
import { ChatHeader } from '../../ChatHeader';
import MessageList from '../MessageList';
import { SignIn } from '../SignIn';
import { authReducer, AuthTypes, initialAuthState, initialSmartChatState, smartChatReducer, SmartChatTypes, } from '../SmartChat/states';
import { GUEST_IDENTITY, chatMessage, sleep } from '../SmartChat/utils';
import { Verify } from '../Verify';
import { PHONE_VALIDATION_SUCCESS_MESSAGE_1, PRIVACY_POLICY_MESSAGE, EXPERIMENT_THREE_WELCOME_TEXT_ONE, CONFIRM_DETAILS_TEXT, } from '../SmartChat/Constants';
import { MessageListWrapper } from '../style';
import { AlertError } from '../AlertError';
import { StartStepButtons } from './startStepButtons';
import { scrollerHandler, useScrollToEnd } from '../../../utils/useScrollToEnd';
import { useBootstrappedChatState } from '../../../providers/ChatBootstrapperProvider';
import { StepNames } from '../SmartChat/states/state/types';
export var SmartChatExperiment3 = function () {
    var chatInputFields = useBootstrappedChatState().chatInputFields;
    var _a = useReducer(smartChatReducer, initialSmartChatState), chatState = _a[0], chatDispatch = _a[1];
    var _b = useReducer(authReducer, initialAuthState), authState = _b[0], authDispatch = _b[1];
    var members = chatState.members;
    var error = authState.error;
    var displayRefTheOther = React.useRef(null);
    var displayRef = React.useRef(null);
    var onButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            chatDispatch({ type: SmartChatTypes.START_STEP_BUTTON_CLICKED, payload: true });
            return [2 /*return*/];
        });
    }); };
    var _c = useState([
        { name: StepNames.MESSAGE_LIST, params: { message: EXPERIMENT_THREE_WELCOME_TEXT_ONE } },
    ]), stepsData = _c[0], setStepsData = _c[1];
    useEffect(function () {
        var delayMessages = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.START_STEP_BUTTONS,
                            },
                        ], false); });
                        return [2 /*return*/];
                }
            });
        }); };
        delayMessages();
    }, []);
    useEffect(function () {
        if (!(chatInputFields === null || chatInputFields === void 0 ? void 0 : chatInputFields.otp)) {
            authDispatch({ type: AuthTypes.ERROR, payload: null });
        }
    }, [chatInputFields]);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!chatState.signInSubmitted) return [3 /*break*/, 3];
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PHONE_VALIDATION_SUCCESS_MESSAGE_1 },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 1:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: PRIVACY_POLICY_MESSAGE },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 2:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.VERIFY,
                            },
                        ], false); });
                        return [3 /*break*/, 6];
                    case 3:
                        if (!chatState.startStepButtonClicked) return [3 /*break*/, 6];
                        return [4 /*yield*/, sleep(1000)];
                    case 4:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.MESSAGE_LIST,
                                params: { message: CONFIRM_DETAILS_TEXT },
                            },
                        ], false); });
                        return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _a.sent();
                        setStepsData(function (prevStepsData) { return __spreadArray(__spreadArray([], prevStepsData, true), [
                            {
                                name: StepNames.SIGNIN,
                            },
                        ], false); });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); })();
    }, [chatState.signInSubmitted, chatState.startStepButtonClicked]);
    var experimentStateHandler = function () {
        chatDispatch({ type: SmartChatTypes.SIGN_IN_SUBMITTED, payload: false });
        chatDispatch({ type: SmartChatTypes.START_STEP_BUTTON_CLICKED, payload: false });
        setStepsData(__spreadArray(__spreadArray([], stepsData, true), [
            {
                name: StepNames.SIGNIN,
            },
        ], false));
    };
    useScrollToEnd(stepsData, displayRefTheOther);
    useEffect(function () {
        if (error) {
            scrollerHandler(displayRef);
        }
    }, [error]);
    var renderStepComponent = function (step, index) {
        var _a;
        switch (step.name) {
            case StepNames.START_STEP_BUTTONS:
                return React.createElement(StartStepButtons, { onButtonClick: onButtonClick });
            case StepNames.MESSAGE_LIST:
                return (React.createElement(MessageList, { identity: GUEST_IDENTITY, members: members, messages: chatMessage((_a = step.params) === null || _a === void 0 ? void 0 : _a.message), userType: 'customer', isExperiment: true, hideDay: true, key: "DelayedMessageList_".concat(stepsData.length, "_").concat(index) }));
            case StepNames.VERIFY:
                return (React.createElement(Verify, { key: "Verify", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, experimentStateHandler: experimentStateHandler }));
            case StepNames.SIGNIN:
                return (React.createElement(SignIn, { key: "signIn", chatState: chatState, chatDispatch: chatDispatch, authState: authState, authDispatch: authDispatch, showEmail: true }));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatHeader, { activePanel: ChatPanels.Default, showBackArrow: true }),
        React.createElement(MessageListWrapper, { isExperiment: true },
            React.createElement(React.Fragment, null, stepsData.map(function (step, index) { return (React.createElement("div", { key: "step_".concat(index) },
                renderStepComponent(step, index),
                React.createElement("div", { ref: displayRefTheOther }))); })),
            React.createElement("div", { ref: displayRef },
                React.createElement(AlertError, { error: error })))));
};
//# sourceMappingURL=index.js.map